/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions} from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'

const RoomDetailsHeader: React.FC = () => {
  let t = Tr()
    const {menuId} = useMenuIdPermissions()
  
  const location = useLocation()
  const roomId = (location.state as any)?.roomId || ''
  const [roomDetails, setRoomDetails] = useState([])

  // room Details api call
  const roomDetailsApiCall = async () => {
    var param: any = {
      roomId: roomId,
    }
    var response: any = await fetchData('vendor/public/roomDetails', param)

    if (response.status == '200') {
      setRoomDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    roomDetailsApiCall()
          document.title = "Insayr | Room Overview"

  }, [])
  
  return (
    <>
      {roomDetails.map((room: any, index: any) => {
        var imageUrl = ''
        var totalImage = ''
        if (room['images'].length != 0) {
          imageUrl = room['images'][0].mediaPath
          totalImage = '+' + (room['images'].length - 1)
        } else {
          imageUrl = toAbsoluteUrl('/media/avatars/300-1.jpg')
          totalImage = ''
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {totalImage ? (
                      <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 d-flex justify-content-center align-items-center'>
                        {totalImage}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {room['en_roomName']}
                        </div>
                      
                      </div>

                   
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{room['availableRoom']}</div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>{t("Available Room")}</div>
                        </div>

                      
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/roomoverview' && 'active')
                      }
                      to={getEncryptedRoute('../roomoverview/' ,{menuId : menuId})}

                      state={{roomId: roomId}}
                    >
                      {t("All Details")}
                    </Link>
                  </li>
               
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export {RoomDetailsHeader}
